import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';
import { PortainerSelect } from '@@/form-components/PortainerSelect';

import { volumeTypeOptions } from './constants';

export function VolumeTypeItem({ item, onChange, index }: ItemProps<string>) {
  return (
    <InputGroup size="small" className="flex-1">
      <InputGroup.Addon>Type</InputGroup.Addon>
      <PortainerSelect
        options={volumeTypeOptions}
        value={item}
        onChange={(value) => onChange(value || '')}
        data-cy={`allowed-volume-type-${index}-select`}
        isClearable={false}
        size="sm"
      />
    </InputGroup>
  );
}
